<div container>
  <div class="section2__container card card--aqua">
    <h2>Learn the symptoms of autoimmune type 1 diabetes</h2>
    <p>Get prepared by learning about and keeping an eye out for symptoms before they appear. Some symptoms to watch out for are:</p>
    <div class="section2__bullets d-flex flex-column flex-lg-row">
      <div class="bullets">
        <ul class="mb-0">
          <li>Excessive thirst</li>
          <li>Frequent urination, including bed-wetting in children who previously didn't wet the bed while asleep</li>
          <li>Extreme hunger</li>
        </ul>
      </div>
      <div class="divider-line d-none d-lg-block"></div>
      <div class="bullets">
        <ul class="mb-0">
          <li>Unintended weight loss</li>
          <li>Irritability and other mood changes</li>
          <li>Fatigue and weakness</li>
        </ul>
      </div>
      <div class="divider-line d-none d-lg-block"></div>
      <div class="bullets">
        <ul>
          <li>Blurred vision</li>
          <li>Dry mouth</li>
          <li>Slow-healing cuts/bruises</li>
        </ul>
      </div>
    </div>
    <h3>Always talk to a doctor about any symptoms you or a loved one may be experiencing.</h3>
  </div>
</div>